var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BravadoRightNavigation',{attrs:{"hide-menu":!_vm.$auth.user}},[_c('JobsPlaceholder')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }